// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"294":"31caaf16","622":"8d0904c1","627":"b486ea5c","884":"c911ebbb"}[chunkId] + ".chunk.css";
};